import React, { useState } from 'react';
import { Star } from 'lucide-react';
import { cn } from '../lib/utils';

export const StarRating = ({ 
  rating = 0, 
  maxRating = 5, 
  size = 'md',
  interactive = false,
  onChange,
  showValue = false,
  className 
}) => {
  const [hoverRating, setHoverRating] = useState(0);
  
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8',
  };
  
  const handleClick = (value) => {
    if (interactive && onChange) {
      onChange(value);
    }
  };
  
  const displayRating = hoverRating || rating;
  
  return (
    <div className={cn("flex items-center gap-1", className)}>
      {[...Array(maxRating)].map((_, index) => {
        const value = index + 1;
        const filled = value <= displayRating;
        
        return (
          <button
            key={index}
            type="button"
            onClick={() => handleClick(value)}
            onMouseEnter={() => interactive && setHoverRating(value)}
            onMouseLeave={() => interactive && setHoverRating(0)}
            className={cn(
              "transition-colors",
              interactive ? "cursor-pointer hover:scale-110 transition-transform" : "cursor-default"
            )}
            disabled={!interactive}
          >
            <Star
              className={cn(
                sizes[size],
                filled ? "fill-yellow-400 text-yellow-400" : "fill-transparent text-slate-300"
              )}
            />
          </button>
        );
      })}
      {showValue && (
        <span className="ml-2 text-sm font-medium text-slate-600">
          {rating > 0 ? rating.toFixed(1) : 'N/A'}
        </span>
      )}
    </div>
  );
};

export const RatingBadge = ({ rating, totalReviews, size = 'md' }) => {
  if (!rating && !totalReviews) {
    return (
      <span className="text-sm text-slate-400">Pas encore d'avis</span>
    );
  }
  
  return (
    <div className="flex items-center gap-2">
      <StarRating rating={rating} size={size} />
      <span className="text-sm text-slate-600">
        {rating?.toFixed(1)} ({totalReviews} avis)
      </span>
    </div>
  );
};

export default StarRating;
